import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';
import { navigateToAdminListings } from '../../lib/adminListingsNavigation';

/**
 * Admin review mode: return to /admin?tab=listings in the same tab only.
 */
export default function AdminReturnToListingsCta({
  navigate,
  t,
  showHint = true,
  showButton = true,
  testId = 'admin-return-to-listings-btn',
  variant = 'default',
  size = 'default',
  className = 'bg-signal-blue hover:bg-signal-blue-hover text-white shrink-0',
}) {
  return (
    <div className="flex flex-col items-stretch sm:items-end gap-2" data-testid="admin-return-to-listings-cta">
      {showHint && (
        <p className="text-xs text-slate-500 leading-snug text-right max-w-[20rem]">
          {t(
            'admin.review_mode_cta_hint',
            'Publish, reject, or add review notes from Admin Listings.',
          )}
        </p>
      )}
      {showButton && (
        <Button
          type="button"
          variant={variant}
          size={size}
          className={className}
          data-testid={testId}
          onClick={() => navigateToAdminListings(navigate)}
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          {t('admin.return_to_admin_listings', 'Return to Admin Listings')}
        </Button>
      )}
    </div>
  );
}
